import { render, staticRenderFns } from "./SideBarBlock.vue?vue&type=template&id=21bff2bf&scoped=true&"
import script from "./SideBarBlock.vue?vue&type=script&lang=ts&"
export * from "./SideBarBlock.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarBlock.vue?vue&type=style&index=0&id=21bff2bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bff2bf",
  null
  
)

export default component.exports